import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=e0fde5da"
import script from "./Webcam.vue?vue&type=script&lang=js"
export * from "./Webcam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports